/* ============================================================
   DENTAL CAVITY — Lógica de la sección
   Prefijo: dc-   |   Aislado por sección (data-dc-section)
   ============================================================ */

/* ---- CONFIGURACIÓN GLOBAL (editable) --------------------- */
window.MI_CONFIG = window.MI_CONFIG || {
  slug: "dental-cavity",
  countdownHours: 3,          // duración del temporizador
  countdownStorageKey: "dc_countdown_deadline",
  resetOnExpire: true         // reinicia el contador al expirar (vía localStorage)
};

/* App de checkout (Releasit COD). El bloque real se inyecta con
   {% render block %} en el .liquid; aquí solo dejamos la referencia. */
window.CHECKOUT_APP = window.CHECKOUT_APP || {
  provider: "Releasit COD Form",
  blockType: "@app",
  note: "El formulario se arrastra dentro de .dc-checkout desde el editor 'Personalizar'."
};

(function () {
  "use strict";

  function init(root) {
    if (!root || root.__dcInit) return;
    root.__dcInit = true;

    /* ---------- GALERÍA ---------- */
    var mainImg = root.querySelector("[data-dc-main-img]");
    var thumbs = root.querySelectorAll("[data-dc-thumb]");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-src");
        if (mainImg && src) mainImg.src = src;
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });

    /* ---------- MINI-RESEÑAS (auto-scroll suave) ---------- */
    var mrTrack = root.querySelector("[data-dc-minirev]");
    if (mrTrack) {
      var mrTimer = setInterval(function () {
        if (!document.body.contains(mrTrack)) { clearInterval(mrTimer); return; }
        var card = mrTrack.querySelector(".dc-minirev__card");
        if (!card) return;
        var step = card.offsetWidth + 14;
        var atEnd = mrTrack.scrollLeft + mrTrack.clientWidth >= mrTrack.scrollWidth - 4;
        mrTrack.scrollTo({ left: atEnd ? 0 : mrTrack.scrollLeft + step, behavior: "smooth" });
      }, 4000);
    }

    /* ---------- COUNTDOWN (3h con reinicio vía localStorage) ---------- */
    var cd = root.querySelector("[data-dc-countdown]");
    if (cd) {
      var hours = parseFloat(cd.getAttribute("data-hours")) || window.MI_CONFIG.countdownHours;
      var key = window.MI_CONFIG.countdownStorageKey + "_" + window.MI_CONFIG.slug;
      var elH = cd.querySelector("[data-cd-h]");
      var elM = cd.querySelector("[data-cd-m]");
      var elS = cd.querySelector("[data-cd-s]");

      function freshDeadline() { return Date.now() + hours * 3600 * 1000; }

      function getDeadline() {
        var raw = null;
        try { raw = localStorage.getItem(key); } catch (e) {}
        var dl = raw ? parseInt(raw, 10) : NaN;
        if (!raw || isNaN(dl) || dl <= Date.now()) {
          dl = freshDeadline();
          try { localStorage.setItem(key, String(dl)); } catch (e) {}
        }
        return dl;
      }

      var deadline = getDeadline();
      var pad = function (n) { return (n < 10 ? "0" : "") + n; };

      function tick() {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          if (window.MI_CONFIG.resetOnExpire) {
            try { localStorage.removeItem(key); } catch (e) {}
            deadline = getDeadline();
            diff = deadline - Date.now();
          } else {
            diff = 0;
          }
        }
        var totalS = Math.max(0, Math.floor(diff / 1000));
        var h = Math.floor(totalS / 3600);
        var m = Math.floor((totalS % 3600) / 60);
        var s = totalS % 60;
        if (elH) elH.textContent = pad(h);
        if (elM) elM.textContent = pad(m);
        if (elS) elS.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    }

    /* ---------- CTA MÓVIL PEGAJOSO (clona el bloque de app) ---------- */
    // (Opcional) Si existe checkout y pantalla pequeña, mostramos barra inferior.
  }

  function boot() {
    document.querySelectorAll("[data-dc-section]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  // Compatibilidad con el editor de temas de Shopify
  document.addEventListener("shopify:section:load", boot);
})();
